<template>
    <div class="w-full">
        <div class="w-full mx-auto mt-20">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    MASTER USER - EDIT
                </h1>
            </div>
            <div class="w-full">
                <form @submit.prevent="update">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <TextInput
                            v-model="form.username"
                            :error="form.errors.username"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Username"
                            disabled="disabled"
                            readonly
                        />
                        <TextInput
                            v-model="form.namaUser"
                            :error="form.errors.namaUser"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Nama User"
                        />
                        <TextInput
                            v-model="form.password"
                            :error="form.errors.password"
                            class="pb-8 pr-6 w-full lg:w-1/2"
                            label="Password"
                            type="password"
                        />
                        <div>
                            <label class="form-label">Admin?</label>
                            <input type="checkbox" v-model="form.isAdmin" />
                        </div>
                    </div>
                    <div class="w-full flex justify-center items-center">
                        <button
                            @click.prevent="destroy"
                            class="btn-red h-16 rounded-3xl mt-8 text-white mx-2 o w-1/2"
                        >
                            Hapus User
                        </button>
                        <button
                            type="submit"
                            class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 text-white m-auto w-1/2"
                        >
                            Simpan User
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <FlashMessage class="mt-5 w-1/2 m-auto" />
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import TextInput from "../../../Shared/TextInput.vue";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
export default {
    data() {
        return {
            form: this.$inertia.form({
                username: this.user.FS_KD_USER,
                namaUser: this.user.FS_NM_USER,
                password: "",
                isAdmin: (this.user.FB_SYS_ADMIN === 1)?true:false,
            }),
        };
    },
    props: {
        user: Object,
    },
    components: {
        Link,
        TextInput,
        FlashMessage,
    },
    layout: LayoutAdmin,
    methods: {
        update() {
            const confirm = window.confirm("Yakin menyimpan data user?");
            if (confirm == 1) {
                this.form.isAdmin
                    ? (this.form.isAdmin = 1)
                    : (this.form.isAdmin = 0);
                this.form.put(`/admin/user/${this.user.FS_KD_USER}`)
                this.form.isAdmin
                    ? (this.form.isAdmin = true)
                    : (this.form.isAdmin = false);
            }
        },
        destroy() {
            const confirm = window.confirm('Yakin akan menghapus data user tersebut?')
            if (confirm==1) {
                this.$inertia.delete(`/admin/user/${this.user.FS_KD_USER}`)
            }
        }
    },
};
</script>
